import BackgroundVideo from '../../../resources/scripts/helpers/background-video';

class BrixImage {
  static init(...parameters) {
    return new BrixImage(...parameters);
  }

  constructor(block) {
    if (block) {
      this.calculateAspectRatio(block);

      const backgroundVideoWrapper = document.querySelector(
        `#${block.id} > .background > .video`,
      );

      if (backgroundVideoWrapper) {
        BackgroundVideo.init(block);
      }
    }
  }

  calculateAspectRatio(block) {
    const image = block.querySelector('.image');

    if (image) {
      const { aspectRatio } = image.dataset;
      if (aspectRatio) {
        image.style.aspectRatio = aspectRatio;
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-image', BrixImage.init);
}
